export function getSelectedIds (): string[] {
  const input = document.getElementById('selected-control-ids') as HTMLInputElement | null
  if ((input != null) && input.value.trim() !== '') {
    return input.value.split(',').map(id => id.trim())
  }
  return []
}

export function addSelection (id: string): void {
  const ids = getSelectedIds()
  if (!ids.includes(id)) {
    ids.push(id)
    updateHiddenInputFromIds(ids)
  }
}

export function removeSelection (id: string): void {
  const ids = getSelectedIds().filter(existingId => existingId !== id)
  updateHiddenInputFromIds(ids)
}

export function updateHiddenInputFromIds (ids: string[]): void {
  const input = document.getElementById('selected-control-ids') as HTMLInputElement
  if (input !== null) {
    input.value = ids.join(',')
  }
}

export function clearAllSelections (): void {
  updateHiddenInputFromIds([])
}
